@import '../../style/index';
@import '../../style/layout/index';

:host {
  display: block;

  .container {
    display: flex;
    justify-content: flex-end;
    margin: 0 auto;
    max-width: $max-width-container-small;

    /* stylelint-disable declaration-no-important */
    @include xlarge-up() {
      max-width: $max-width-container-xlarge !important;
    }

    @include xxlarge-up() {
      max-width: $max-width-container-xxlarge !important;
    }

    rcm-button {
      position: fixed;
      bottom: 0;
      overflow: hidden;
      border-top-right-radius: rem-calc(4px);
      border-top-left-radius: rem-calc(4px);
      font-weight: $font-weight-regular;
      z-index: 550;

      &:focus {
        outline: 2px solid var(--colors-raiffeisen-blue);
      }
    }
  }
}
